import {
    FILTER_PINNED,
    FILTER_NOT_PINNED,
    FILTER_FEATURE_SCOOTER_LIST,
    FILTER_FEATURE_SCOOTER_MAP,
    FILTER_FEATURE_TICKET_LIST,
    FILTER_FEATURE_TICKET_ASSIGNMENT,
    FILTER_FEATURE_ADDITIONAL_FEE,
    FILTER_OVER_LIMITED_SIZE,
    FILTER_FILE_INVALID,
    FILTER_FILE_EMPTY,
    FILTER_NOT_EXISTS,
    FILTER_UNAUTHED,
    DELETE_UNAUTHED_FILTERS,
    DELETE_UNEXIST_FILTERS,
    FILTER_OVER_PIN_SIZE,
    FILTER_CRITERIA_ERROR,
    FILTER_NOT_FOUND,
    FILTER_FLEET_USR_NOT_MATCH,
} from 'constants/filters';

import {
    SCOOTER_LIST,
    SCOOTER_MAP,
    TICKET_LIST,
    TICKET_ASSIGNMENT,
    ADDITIONAL_FEE
} from 'constants/routes';

import routes from './routes';

const pinnedMap = {
    [FILTER_PINNED]: 'Yes',
    [FILTER_NOT_PINNED]: 'No',
};

const featuresMap = {
    [FILTER_FEATURE_SCOOTER_LIST]: routes[SCOOTER_LIST],
    [FILTER_FEATURE_SCOOTER_MAP]: routes[SCOOTER_MAP],
    [FILTER_FEATURE_TICKET_LIST]: routes[TICKET_LIST],
    [FILTER_FEATURE_TICKET_ASSIGNMENT]: routes[TICKET_ASSIGNMENT],
    [FILTER_FEATURE_ADDITIONAL_FEE]: routes[ADDITIONAL_FEE],
};

const filters = {
    'shortcut_title': 'Your Pinned Filters',
    'go_to_filters_management': 'Manage Filters',
    'empty_filters': 'No Pinned Filters',
    'search_box_placeholder': 'Enter Filter Name...',
    'filter_feature': 'Feature',
    'filter_pinned': 'Pinned',
    'pinned_map': pinnedMap,
    'features_map': featuresMap,
    'new': 'New Filter',
    'result': 'Filtered Page',
    'update_time': 'Updated Time',
    'link': 'Link',
    'name': 'Filter Name',
    'id': 'Filter No.',
    'export_title': 'Please paste the sourced filter No. below:',
    'browse_file': 'Browse file',
    [`import_error_${ FILTER_OVER_LIMITED_SIZE }`]: 'Exceeded the filter amount (200 filters max)',
    [`import_error_${ FILTER_FILE_INVALID }`]: 'File Invalid (Please ensure the file is in csv format and the header matches the template header)',
    [`import_error_${ FILTER_FILE_EMPTY }`]: 'File Invalid (Can\'t find Filter No.)',
    [`import_error_${ FILTER_NOT_EXISTS }`]: 'Filter not found: %{filterId}',
    [`import_error_${ FILTER_UNAUTHED }`]: 'You don\'t have the permission to import this filter. Please check the filter settings and your user permissions: %{filterId}',
    'remove': 'Delete',
    'confirm_remove': 'Are you sure to delete the selected filters?',
    [`delete_error_${DELETE_UNAUTHED_FILTERS}`]: 'You don\'t have the permission to delete this filter. Please check the filter settings and your user permissions',
    [`delete_error_${DELETE_UNEXIST_FILTERS}`]: 'The filter does not exist',
    'filter_detail_title': 'Filter Details',
    'details': 'Details',
    'description': 'Description',
    'criteria_sorting': 'Sorting',
    'criteria_filters': 'Filters',
    [`create_upd_error_${ FILTER_OVER_LIMITED_SIZE }`]: 'Exceeded the filter amount (200 filters max)',
    [`create_upd_error_${ FILTER_OVER_PIN_SIZE }`]: 'Exceeded the pinned filter amount',
    [`create_upd_error_${ FILTER_CRITERIA_ERROR }`]: 'Please remove the invalid sorting or filter settings and try again.',
    [`create_upd_error_${ FILTER_UNAUTHED }`]: 'Unauthorized filter',
    [`create_upd_error_${ FILTER_FLEET_USR_NOT_MATCH }`]: 'You don\'t have the permission to edit this filter. Please check the filter settings and your user permission.',
    [`create_upd_error_${ FILTER_NOT_FOUND }`]: 'The filter does not exist',
    'invalid': 'Invalid',
    'criteria_can_not_edit': 'Click edit to update the sorting and filter settings.',
};

export default filters;
